import React from 'react';
import { Progress } from '../ui/progress';
import { Check } from 'lucide-react';
import { cn } from '../../lib/utils';

const AchievementCard = ({ achievement, className }) => {
  const { title, description, icon, progress, earned, current, total } = achievement;

  return (
    <div 
      className={cn(
        'card-elevated p-4',
        earned && 'border-success/30 bg-success-light/20',
        className
      )}
    >
      <div className="flex items-start gap-4">
        {/* Icon */}
        <div className={cn(
          'w-14 h-14 rounded-xl flex items-center justify-center text-2xl shrink-0',
          earned ? 'bg-success/10' : 'bg-muted'
        )}>
          {earned ? (
            <div className="relative">
              <span>{icon}</span>
              <div className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-success flex items-center justify-center">
                <Check className="w-3 h-3 text-success-foreground" />
              </div>
            </div>
          ) : (
            <span className="grayscale opacity-50">{icon}</span>
          )}
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <h4 className={cn(
            'font-semibold',
            earned ? 'text-success' : 'text-foreground'
          )}>
            {title}
          </h4>
          <p className="text-sm text-muted-foreground mt-0.5">{description}</p>
          
          {!earned && (
            <div className="mt-3 space-y-1.5">
              <div className="flex items-center justify-between text-xs">
                <span className="text-muted-foreground">Progresso</span>
                <span className="font-medium">{current}/{total}</span>
              </div>
              <Progress value={progress} className="h-1.5" />
            </div>
          )}

          {earned && (
            <p className="text-xs text-success mt-2 font-medium">
              ✓ Conquistado!
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AchievementCard;
